const css = `._kbd_11gso_1 {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-family: system-ui, -apple-system, sans-serif;
}

._key_11gso_8 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  font-family: inherit;
}

._separator_11gso_26 {
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  margin: 0 1px;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {"kbd":"_kbd_11gso_1","key":"_key_11gso_8","separator":"_separator_11gso_26"};